const LOCAL_STORAGE = {
  // TODO: change to promobit.access-token
  ACCESS_TOKEN: 'apiToken',
  DEPRECATED_LOGGED_IN_USER: 'loggedInUser',
  DEPRECATED_USER_PHOTO: 'me.photo',
  IS_POLICY_NUMBER_1_ACCEPTED: 'police.cookie_1',
  IS_POLICY_NUMBER_2_ACCEPTED: 'police.cookie_2',
  IS_POLICY_NUMBER_3_ACCEPTED: 'police.cookie_3',
  IS_POLICY_NUMBER_5_ACCEPTED: 'police.cookie_5',
  IS_SHOWING_LGPD_ALERT: 'police.show_modal',
  // Promobit 2.0
  IS_DARK_MODE_ACTIVE: 'promobit.is-dark-mode-active',
  IS_DOWNLOAD_APP_DIALOG_ACTIVE:
    'promobit.is-download-app-cta-component-home-ab-test',
  IS_EXTENSION_ACTIVE: 'promobit_extensions',
  IS_INTERNATIONAL_OFFERS_ACTIVE: 'promobit.is-international-offers-active',
  // Intent banner: per-campaign frequency ledger (JSON). Tracks last-shown
  // timestamp, daily/total view counts and the post-CTA stop flag, keyed by
  // campaign id. See lib/intentBannerFrequency.
  INTENT_BANNER_FREQUENCY: 'promobit.intent-banner-frequency',
  IS_SUPIX_COLLECTED: 'promobit.is-supix-collected-v2',
  IS_WISHLIST_MAINTENANCE_ALREADY_INTERACTED:
    'promobit.is-wishlist-maintenance-already-interacted',
  POST_LOGIN_TOAST: 'promobit.post-login-toast',
  SHOWED_WELCOME_NOTIFICATION: 'showedWelcomeNotification',
  SUPIX_GENERATED_SESSION: 'supix.s',
  WEBPUSH_HASH: 'webpush-hash',
};

export default LOCAL_STORAGE;
